export const getStageElementByRefRecursively = (input, ref, pathToStage = [] ) => {
  if (typeof ref !== 'string') {
    throw new Error('Invalid parameter: key and value has to be a string.');
  }
  // Accepts arrays of objects.
  if (Array.isArray(input)) {
    return input.reduce((acc, item, i) =>
      getStageElementByRefRecursively(input[i], ref, [...pathToStage, i]) || acc, null
    );
  }
  
  // Process objects.
  if (input !== null && typeof input === 'object') {
    if (input.ref === ref || input.data?.ref === ref) return {element: input, keyPathToElement: pathToStage};
    return ['stage', 'sections', 'rows','columns','stageElements', 'value', 'children','data', 'introSection'].reduce((acc, key) =>
      getStageElementByRefRecursively(input[key], ref, [...pathToStage, key]) || acc, null
    );
  }
  return null;
};